module.exports = __webpack_public_path__ + "static/media/edit.7c9a16c3.svg";